import IWorkflow from '@interfaces/IWorkflow';
import { TicketStatus } from '@interfaces/ticket-status';
import AppContext from '@services/Context';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Badge, Col, Icon, Row } from 'antd';
import * as React from 'react';

import ItemComponent from './ItemHistoryComponent';

interface IProp {
  registers: any,
  ticketStatus?: TicketStatus,
  ticketStatusLabel?: string,
  workflow?: IWorkflow,
  extralfield: any
}

class HistoryComponentEhss extends React.Component<IProp, {}> {

  renderTimelineItem(register: any, i: number) {
    return (
      <ItemComponent
        id={i}
        key={i}
        register={register}
        type={this.getTypeFromRegister(register)}
        name={this.getNameFromRegister(register)}
        extrafields={this.props.extralfield}
      />
    )
  }

  getTypeFromRegister(register: any) {

    let typeFound: number = 1;

    typeFound = this.getRegisterType(register) || 1;

    switch (typeFound) {
      case 1:
        return "process"
      case 2:
        return "notification"
      case 3:
        return "report"
      default:
        return "errorOnType"
    }
  }

  getNameFromRegister(register: any) {
    return register.label;
  }

  getRegisterType(register: any) {
    return register.workflowEventType ? register.workflowEventType : register.workflowEvent.type;
  }

  getFinalDotElement(isComplete: boolean) {
    return (
      <Badge status="processing" className="goepik-timeline-number" />
    )
  }

  getFinalLabel(customLabel?: string) {
    switch (this.props.ticketStatus) {
      case TicketStatus.OPENED:
        return I18n.l('global.ticket.status.started');

      case TicketStatus.CLOSED:
        return (
          <h3 className="goepik-status-done">
            <Icon type="check-circle" />
            {I18n.l('common.status')} "{I18n.l('global.ticket.status.done')}"
                            </h3>
        )

      case TicketStatus.CANCELED:
        return (
          <h3 className="goepik-status-error">
            <Icon type="close-circle" />
            {I18n.l('common.status')} "{I18n.l('global.ticket.status.error')}"
                            </h3>
        )

      case TicketStatus.IN_PROGRESS:
        if (customLabel != undefined) {
          return (
            <h3 className="goepik-status-in-progress">
              <Icon type="clock-circle" />
              {I18n.l('common.status')} "{this.props.ticketStatusLabel}"
                        </h3>
          )
        } else {
          return (
            <h3 className="goepik-status-in-progress">
              <Icon type="clock-circle" />
              {I18n.l('common.status')} "{I18n.l('global.ticket.status.inprogress')}"
                        </h3>
          )
        }

      default:
        return "Error on Ticket Status";
    }
  }

  renderTimeline(registers: any) {
    return (
      <div>
        {this.renderTimelineItem(registers[0], 0)}
      </div>
    );
  }

  render(): JSX.Element {
    return (
      <AppContext.Consumer>
        {({ theme }) => (
          <Row className="goepik-component-padding">
            <Col sm={24} md={24} xl={24} className="goepik-component-padding">
              <Row>
                <Col sm={16} md={16} xl={16}>
                  <GoEpikHistoryTimeline>
                    {
                      this.renderTimeline(this.props.registers)
                    }
                  </GoEpikHistoryTimeline>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </AppContext.Consumer>
    );
  }
};

const GoEpikHistoryTimeline = styled.div`
    .goepik-timeline-number{
        .ant-badge-count{
            background-color: ${Theme.primary.regular}!important;
            color: ${Theme.standard.white}!important;
            box-shadow: '0 0 0 1px #d9d9d9 inset!important'
        }
    }
    .goepik-span-number span {
        margin-right: 0.5rem;
        color: #28AADC;
        font-weight: bold;
    }

    .goepik-history-status{
        .anticon{
            padding-right: 6px;
        }

        .goepik-status-in-progress{
            color: ${Theme.status.inProgress};
        }

        .goepik-status-done{
            color: ${Theme.status.done || '#28DCAA'};
        }

        .goepik-status-error{
            color: ${Theme.status.error};
        }
    }
`;

export default HistoryComponentEhss;
